var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var Report = function (props) {
    var titleId = id("title", props);
    var title = props.title, fill = props.fill, rest = __rest(props, ["title", "fill"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest),
        React.createElement("title", { id: titleId }, title),
        React.createElement("g", { id: "Layer_2" },
            React.createElement("path", { fill: fill, d: "M18.37,5.54a.61.61,0,0,0,0-.13.75.75,0,0,0-.09-.15s0,0,0-.06h0L13.81.55h0a.48.48,0,0,0-.16-.12l0,0-.12,0-.13,0H7.5A.65.65,0,0,0,6.85,1V15.39A.65.65,0,0,0,7.5,16H17.74a.65.65,0,0,0,.65-.65V5.64S18.37,5.58,18.37,5.54ZM14,2.63,16.23,5H14Zm3.1,12.11H8.15V1.65h4.54v4a.65.65,0,0,0,.65.65h3.75Z" }),
            React.createElement("path", { fill: fill, d: "M16.22,16.77l-10.29.07V2.43a.65.65,0,0,0-1.3,0V16.84a1.23,1.23,0,0,0,1.23,1.23H16.22a.65.65,0,1,0,0-1.3Z" }))));
};
Report.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    fill: PropTypes.string
};
Report.defaultProps = {
    id: "report-icon",
    title: "Reports",
    fill: "#3d3d35"
};
export default Report;
